import { supabase } from '../lib/supabase';

export interface LoandiskBorrower {
  loandisk_borrower_id: string;
  loandisk_branch_id: string | null;
  unique_number: string | null;
  full_name: string | null;
  first_name: string | null;
  last_name: string | null;
  mobile: string | null;
  email: string | null;
  address: string | null;
  city: string | null;
  province: string | null;
  photo_url: string | null;
  synced_at: string | null;
}

export interface LoandiskLoan {
  loandisk_loan_id: string;
  unique_number: string | null;
  loan_number: string | null;
  loan_product_name: string | null;
  principal_amount: number | null;
  loan_balance: number | null;
  loan_status: string | null;
  released_date: string | null;
  maturity_date: string | null;
  synced_at: string | null;
}

const borrowerFields =
  'loandisk_borrower_id, loandisk_branch_id, unique_number, full_name, first_name, last_name, mobile, email, address, city, province, photo_url, synced_at';
const loanFields =
  'loandisk_loan_id, unique_number, loan_number, loan_product_name, principal_amount, loan_balance, loan_status, released_date, maturity_date, synced_at';

export const borrowerName = (
  borrower: Pick<LoandiskBorrower, 'full_name' | 'first_name' | 'last_name'>
) =>
  borrower.full_name
  || [borrower.first_name, borrower.last_name].filter(Boolean).join(' ')
  || 'Unnamed borrower';

export async function getLoandiskBorrower(
  uniqueNumber: string
): Promise<LoandiskBorrower | null> {
  const { data, error } = await supabase
    .from('loandisk_borrowers')
    .select(borrowerFields)
    .eq('unique_number', uniqueNumber)
    .maybeSingle();

  if (error) throw error;
  return data as LoandiskBorrower | null;
}

export async function getBorrowerLoans(uniqueNumber: string): Promise<LoandiskLoan[]> {
  const { data, error } = await supabase
    .from('loandisk_loans')
    .select(loanFields)
    .eq('unique_number', uniqueNumber)
    .order('released_date', { ascending: false });

  if (error) throw error;
  return (data || []) as LoandiskLoan[];
}
